<template>
    <div class="outer">
        
        <el-dialog
            title="提示"
            :visible.sync="dialogVisible"
            @close="closeDialog"
            width="25%">
            <el-form label-width="80px" ref="approveForm" :model="approveForm" :rule="approveRule" class="dialogForm">
                <el-form-item label="审批意见">
                    <el-input v-model="approveForm.opinion"  placeholder="请输入内容"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer" v-if="approvalType == 'approval'">
                <el-button type="danger" :disabled="btnLoading" @click="requestApproval(2)">驳 回</el-button>
                <el-button type="primary" :disabled="btnLoading"  @click="requestApproval(1)" v-if="queryForm.func == 2">通 过</el-button>
            </span>
        </el-dialog>

        <div class="topSearch">
            <el-form class="queryRow" inline :model="queryForm">
                <el-form-item label="请购单状态" class="queryCol">
                    <el-select v-model="queryForm.func" @change="onSearch">
                        <el-option :value="2" label="待审批"></el-option>
                        <el-option :value="1" label="已审批"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
        </div>

        <el-table border v-loading="loading" class="table" :row-style="{ height: '50px' }"  style="width: 100%;height: 70vh;overflow: auto;" :cell-class-name="cellClassName" :data="requestGoodsList">
            <!-- <el-table-column type="expand" label=" " width="50">
                <template slot-scope="props">
                    <el-descriptions title="项目信息" class="demo-table-expand" :column="1">
                        <el-descriptions-item label="商机号">{{ props.row.chanceId }}</el-descriptions-item>
                        <el-descriptions-item label="商机名称">{{ props.row.chanceName }}</el-descriptions-item>
                    </el-descriptions>
                </template>
            </el-table-column> -->
            <template slot="empty">
                <el-empty :image-size="150"></el-empty>
            </template>
            <el-table-column align="center" label="请购单编号" prop="requestNo" width="180">
            </el-table-column>
            <!-- <el-table-column align="center" label="申领用途类型" prop="usageTypeName">
            </el-table-column> -->
            <el-table-column align="center" label="请购单状态" prop="requestState">
                <template slot-scope="scope">
                    <el-tag :type="RstateTagType(scope.row.requestState)">{{ scope.row.requestStateName || '已入库' }}</el-tag>
                </template>
            </el-table-column>
            <el-table-column align="center" label="请购人" prop="requestUserName">
            </el-table-column>
            <el-table-column align="center" label="货物名称" prop="goodsName">
            </el-table-column>
            <el-table-column align="center" label="货物品牌" prop="goodsBrand">
            </el-table-column>
            <el-table-column align="center" label="货物型号" prop="goodsType">
            </el-table-column>
            <el-table-column align="center" label="货物配置" prop="goodsConfig">
                <template slot-scope="scope">
                    <el-popover trigger="hover" placement="top" width="300">
                        <p>{{ scope.row.goodsConfig }}</p>
                        <div slot="reference">
                            <p size="medium" style="white-space: nowrap;overflow: hidden;text-overflow:ellipsis;">{{ scope.row.goodsConfig}}</p>
                        </div>
                    </el-popover>
                </template>
            </el-table-column>
            <el-table-column align="center" label="请购数量" prop="goodsNum">
                <template slot-scope="scope">
                    <span>{{ scope.row.goodsNum }}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" label="货物单位" prop="goodsUnit">
            </el-table-column>
            <el-table-column align="center" label="备注" prop="remarks">
            </el-table-column>
            <el-table-column align="center" label="审批意见" prop="opinion" v-if="queryForm.func == 1">
            </el-table-column>
            <el-table-column align="center" label="关联采购单号" prop="purchaseNo" width="180" v-if="queryForm.func == 1">
                <template slot-scope="scope">
                    <el-button type="text" @click="goPurchaseList(scope.row.purchaseNo)" v-if="scope.row.purchaseNo">{{ scope.row.purchaseNo }}</el-button>
                    <span v-else>--</span>
                </template>
            </el-table-column>
            <el-table-column align="center" label="操作" prop="operate">
                <template slot-scope="scope" >
                    <el-button type="text" icon="el-icon-s-order" v-if="scope.row.requestState != 3 && !scope.row.purchaseNo"
                        @click="openDialog(scope.row, 'approval')">审批</el-button>
                </template>
            </el-table-column>
        </el-table>

        <div class="pageination">
            <el-pagination @size-change="onSizeChange" @current-change="onCurrentChange" :total="total"
                :page-size="queryForm.limit" :page-sizes="[10, 20, 30, 40, 50, 100]" :current-page="queryForm.page"
                background layout="sizes, prev, pager, next, jumper, ->, total">
            </el-pagination>
        </div>
    </div>
</template>
<script>
import { applyApprovalReject } from '@/api/goods/applyForm.js';
import { getAllProject } from '@/api/work/WorkOrderList.js';
import { requestApprovedList } from '@/api/goods/request.js';
export default {
    data() {
        return {
            btnLoading: false, // 提交按钮是否禁用
            approveForm: {
                opinion: '',
                applyCode: '',
            },
            approveRule: {
                opinion: [
                    { required: true, message: '审批意见不能为空' },
                ],
            },
            dialogVisible: false,
            total: 0,
            queryForm: {
                func: 2,
                chanceId: '',
                usageType: '',
                applyState: '',
                page: 1,
                limit: 10,
            },
            requestGoodsList: [],
            projectList: [],
            loading: false,
            approvalType: '',
        }
    },
    created() {
        this.fetchRequestGoodsList();
        this.getAllProject();
    },
    computed: {
    },
    methods: {
        // 跳转采购订单详情页
        goPurchaseList(purchaseNo){
            this.$router.push({
                name: '行政货物采购',
                params: {
                    purchaseNo: purchaseNo
                }
            })
        },
        closeDialog(){
            this.approveForm.opinion = '';
            this.approveForm.applyCode = '';
            this.approveForm.id = '';
            this.$refs.approveForm.resetFields();
            this.dialogVisible = false;
        },
        // 打开弹窗
        openDialog(row, type){
            this.approvalType = type;
            this.approveForm.id = row.id;
            this.approveForm.applyCode = row.requestNo;
            this.dialogVisible = true;
        },
        // 请购单审批
        requestApproval(approvalResult){
            this.$refs.approveForm.validate((valid) => {
                if (valid) {
                    this.btnLoading = true;
                    applyApprovalReject({
                        approvalType: 5,
                        applyCode: this.approveForm.applyCode,
                        approvalResult: approvalResult,
                        opinion: this.approveForm.opinion
                    }).then(res => {
                        this.btnLoading = false;
                        if(res.code === 200){
                            this.$message({
                                type: 'success',
                                message: '操作成功',
                            });
                            this.queryForm.func = 1
                            this.dialogVisible = false;
                            this.fetchRequestGoodsList();
                        }
                    })
                }
            });
        },
        // 当每页条数变化
        onSizeChange(e) {
            this.queryForm.page = 1;
            this.queryForm.limit = e;
            this.fetchRequestGoodsList();
        },
        // 当页码发生变化时
        onCurrentChange(e) {
            this.queryForm.page = e;
            this.fetchRequestGoodsList();
        },
        onSearch() {
            this.queryForm.page = 1;
            this.fetchRequestGoodsList();
        },
        // 表格单元格样式
        cellClassName({ row, column }) {
            if (column.type === 'expand' && row.usageType != '1') {
                return 'hidden-row'
            }
            return ''
        },
        fetchRequestGoodsList() {
            this.loading = true;
            requestApprovedList(this.queryForm).then(res => {
                if (res.code === 200) {
                    this.total = res.count;
                    this.requestGoodsList = res.data;
                    this.loading = false;
                }
            })
        },
        RstateTagType(requestState){
            switch (requestState) {
                case '1':
                    return '';
                    break;
                case '2':
                    return 'success';
                    break;
                case '3':
                    return 'danger';
                    break;
                case '4':
                    return 'primary';
                    break;
            }

        },
        getAllProject() {
            getAllProject().then(res => {
                if (res.code === 200) {
                    this.projectList = res.result
                }
            })
        }
    },
}
</script>
<style lang="scss" scoped>
.outer {

    .listTop {
        margin-bottom: 15px;
        font-size: 15px;
        font-weight: 450;
    }

    .demo-table-expand {
        font-size: 0;
        margin-left: 65px;

        ::v-deep .el-form-item__label {
            width: 90px;
            color: #99a9bf;
        }

        .el-form-item {
            margin-right: 0;
            margin-bottom: 0;
            width: 50%;
        }
    }

    .clearfix {
        display: flex;
        justify-content: flex-end;
    }

    .el-form-item {
        margin-right: 20px;
    }

    .pageination {
        display: flex;
        justify-content: flex-end;
        margin-top: 5px;
    }

    .topSearch {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
    }

    .queryRow {
        overflow: hidden;
        display: flex;

        .queryName {
            width: 300px;
            margin-right: 10px;
        }

        .dataPicker {
            margin-right: 10px;
        }
    }

    .detailTable {
        ::v-deep .el-checkbox__input {
            &.is-checked {
                .el-checkbox__inner {
                    background-color: #409EFF;
                    border-color: #409EFF;
                }
            }
        }
    }

    .table {

        ::v-deep .hidden-row .cell {
            visibility: hidden;
        }

        ::v-deep .el-tooltip__popper {
            font-size: 14px;
            max-width: 40%
        }

        ::v-deep .el-table__cell {
            >:empty::before {
                content: '--';
                color: gray;
            }
        }
    }
}
</style>